import { render, staticRenderFns } from "./ContentRightsPreview.vue?vue&type=template&id=20a54988&scoped=true&"
import script from "./ContentRightsPreview.vue?vue&type=script&lang=js&"
export * from "./ContentRightsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContentRightsPreview.vue?vue&type=style&index=0&id=20a54988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a54988",
  null
  
)

export default component.exports